import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Estado } from './estado.model';

export class RecuperacaoCredito extends BaseEntity {
	public cnpjAgenteFinanceiro: string;
	public idOperacao: number;
	public idOperacaoExterno: string;
	public sistemaRepasse: string;
	public contratoRepasse: number;
	public estado: Estado;
	public dataEnvio: Date;
	public dataRecuperacao?: Date;
	public valorRecuperacao?: number;
	public valorDevidoAoFgiPeac?: number;
	public valorHonradoARecuperarAntes?: number;
	public valorHonradoARecuperarDepois?: number;
	public saldoLiquidado?: string;
	public reversaoHonra?: string;
	public temMulta?: string;
	public dataPagamentoCobranca?: Date;
	public estornoManual: string;
  public cestaNumero: number;

	public detalhe: DetalheRecuperacaoCredito;

	public resolucoes: ResolucaoInconsistenciaRecuperacaoCredito[];
}

export class ResolucaoInconsistenciaRecuperacaoCredito extends BaseEntity {
	public estado: string;

	public tipoInconsistenciaRecuperacaoCredito: string;

	public observacoes: string;

	public ideRecuperacaoCredito: number;
}

export class DetalheRecuperacaoCredito {
	public identificadorCobranca: number;
	public historicoEstados: HistoricoEstadoRecuperacaoCredito[];
}


export class HistoricoEstadoRecuperacaoCredito {
    public id: number;
	public dataUltimaAtualizacao: Date;
	public estado: Estado;
	public nomeUsuarioResponsavel: string;
}


export class RecuperacaoCreditoEnvio {
	public dataRecuperacao: Date;
	public valorRecuperacao: number;
	public saldoLiquidado: string;
}


export class InformeRecuperacaoCredito {
	public idOperacaoAgenteCreditoLivre: string;
	public sistemaRepasse: string;
	public contratoRepasse: string | number;
	public recuperacoesCredito: RecuperacaoCreditoEnvio[];
}


export class LoteRecuperacoesCreditoEnvio {
	public cnpjAgenteFinanceiro: string;
	public idProtocoloArquivoASerSubstituido?: string;
	public informesRecuperacaoCredito: InformeRecuperacaoCredito[];
}

export class ResultadoCalculoValorHonradoARecuperar {
	public dataCotacaoUtilizadaNaAtualizacao: Date;
	public valorCotacaoUtilizadoNaAtualizacao: number;

	public valorHonraHistorico: number;
	public valorHonraAtualizadoAteDataReferencia: number;

	public valorReversaoHonraHistorico: number;
	public valorReversaoHonraExcedente: number;
	public valorTotalReversaoHonraAtualizadoAteDataReferencia: number;

	public valorRecuperacaoCreditoHistorico: number;
	public valorRecuperacaoCreditoExcedente: number;
	public valorTotalRecuperacaoAtualizadoAteDataReferencia: number;

	public valorHonradoARecuperarHistorico: number;
	public valorHonradoARecuperarAtualizado: number;
}

// JSON de exemplo de recuperação de crédito para exportação de arquivo de exemplo

export const recuperacaoCreditoExemplo =
`
{

	"cnpjAgenteFinanceiro":"58017179000170",
	"informesRecuperacaoCredito":[
		{
			"idOperacaoAgenteCreditoLivre":"OPE-TESTE-1",
			"recuperacoesCredito":[
				{
				"dataRecuperacao":"2021-06-01",
				"valorRecuperacao":100,
				"saldoLiquidado":"N"
				},
				{
				"dataRecuperacao":"2021-06-02",
				"valorRecuperacao":100,
				"saldoLiquidado":"N"
				}
			]
		},
		{
			"sistemaRepasse" : "89",
			"contratoRepasse":"22222222222",
			"recuperacoesCredito":[
				{
				"dataRecuperacao":"2021-07-01",
				"valorRecuperacao":100,
				"saldoLiquidado":"N"
				}
			]
		}
	]
}
`;
